import { SettingsOutlined } from '@mui/icons-material';
import { Box, Button, Divider, Popover } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import ColumnControl from './ColumnControl';

const ColumnManagement = ({
  columns,
  columnVisibilityModel,
  onColumnReorder,
  onColumnVisibilityChange,
  onReset,
  autosizeGrid,
  saveColumnConfig,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    autosizeGrid();
    saveColumnConfig();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'column-controls' : undefined;

  const onDragEnd = ({ destination, source }) => {
    // dropped outside the list
    if (!destination) return;

    onColumnReorder(source.index, destination.index);
  };

  return (
    <>
      <Button aria-describedby={id} variant='outlined' sx={{ minWidth: '10px', padding: '8px' }} onClick={handleClick}>
        <SettingsOutlined sx={{ width: 20, height: 20, color: 'gray' }} />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              width: '275px',
            },
          },
        }}
      >
        <Box sx={{ padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <p className='font-semibold'>Customize Columns</p>
          <Button sx={{ textDecorationLine: 'underline', padding: 0, minWidth: 0 }} disableRipple onClick={onReset}>
            Reset
          </Button>
        </Box>
        <Divider />
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId='droppable-list-columns'>
            {provided => (
              <div ref={provided.innerRef} {...provided.droppableProps} className='p-[12px]'>
                {columns.map((column, index) => (
                  <ColumnControl
                    column={column}
                    index={index}
                    key={column.field}
                    onColumnVisibilityChange={onColumnVisibilityChange}
                    columnVisible={!!(columnVisibilityModel[column.field] ?? true)}
                  />
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Popover>
    </>
  );
};

ColumnManagement.propTypes = {
  columns: PropTypes.array,
  columnVisibilityModel: PropTypes.object,
  onColumnReorder: PropTypes.func,
  onColumnVisibilityChange: PropTypes.func,
  onReset: PropTypes.func,
  autosizeGrid: PropTypes.func,
  saveColumnConfig: PropTypes.func,
};

export default ColumnManagement;
